import { throwError } from 'rxjs';
export function aiUnavailable() {
  return throwError(() => ({ status: 503, error: { code: 'AI_DISABLED', msg: 'AI temporarily unavailable' } }));
}
